import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	tooltip: {
		defaultMessage: 'Help',
		id: 'atlassian-navigation.help.tooltip',
		description: 'Tooltip for "Help" menu item',
	},
	label: {
		defaultMessage: 'Help',
		id: 'atlassian-navigation.help.label',
		description: 'Button label for "Help" menu item',
	},
});
